import { WhiteFlag } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconWhiteFlag12Line = createIcon(WhiteFlag, 12, "Line");
export const IconWhiteFlag16Line = createIcon(WhiteFlag, 16, "Line");
export const IconWhiteFlag20Line = createIcon(WhiteFlag, 20, "Line");
export const IconWhiteFlag24Line = createIcon(WhiteFlag, 24, "Line");
export const IconWhiteFlag32Line = createIcon(WhiteFlag, 32, "Line");
export const IconWhiteFlag48Line = createIcon(WhiteFlag, 48, "Line");
export const IconWhiteFlag64Line = createIcon(WhiteFlag, 64, "Line");
